module.exports = __webpack_public_path__ + "img/social-google.975339a9.svg";